var _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _mask0, _path17, _path18, _mask1, _path19, _path20, _mask10, _path21, _path22, _mask11, _path23, _path24, _mask12, _path25, _path26, _mask13, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackroundWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 22,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 22,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4734 29.8605C41.8532 28.9196 42.1643 27.9523 42.4043 26.9663L22 22L41.4734 29.8605Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4734 29.8605C41.8532 28.9196 42.1643 27.9523 42.4043 26.9663L22 22L41.4734 29.8605Z",
    fill: "#86BB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4734 29.8605C41.8532 28.9196 42.1643 27.9523 42.4043 26.9663L22 22L41.4734 29.8605Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-1-outside-1_4307_3126)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-2_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 21,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 21,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8492 36.8492C38.8119 34.8866 40.366 32.5543 41.4217 29.9872L22 22L36.8492 36.8492Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8492 36.8492C38.8119 34.8866 40.366 32.5543 41.4217 29.9872L22 22L36.8492 36.8492Z",
    fill: "#77CCCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8492 36.8492C38.8119 34.8866 40.366 32.5543 41.4217 29.9872L22 22L36.8492 36.8492Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-2-outside-2_4307_3126)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-3_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 16,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 16,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5671 40.1476C33.9087 39.3664 35.1595 38.4389 36.2967 37.382L22 22L32.5671 40.1476Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5671 40.1476C33.9087 39.3664 35.1595 38.4389 36.2967 37.382L22 22L32.5671 40.1476Z",
    fill: "#99439D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5671 40.1476C33.9087 39.3664 35.1595 38.4389 36.2967 37.382L22 22L32.5671 40.1476Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-3-outside-3_4307_3126)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-4_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 5,
    height: 23,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 5,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3276 42.958C24.0106 42.9147 24.6911 42.8381 25.3667 42.7284L22 22L23.3276 42.958Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3276 42.958C24.0106 42.9147 24.6911 42.8381 25.3667 42.7284L22 22L23.3276 42.958Z",
    fill: "#86BB00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3276 42.958C24.0106 42.9147 24.6911 42.8381 25.3667 42.7284L22 22L23.3276 42.958Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-4-outside-4_4307_3126)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-5_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 12,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 12,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5103 42.7045C28.0335 42.2768 30.4572 41.3914 32.662 40.092L22 22L25.5103 42.7045Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5103 42.7045C28.0335 42.2768 30.4572 41.3914 32.662 40.092L22 22L25.5103 42.7045Z",
    fill: "#123051"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5103 42.7045C28.0335 42.2768 30.4572 41.3914 32.662 40.092L22 22L25.5103 42.7045Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-5-outside-5_4307_3126)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-6_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 17,
    height: 17,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2187 37.4541C36.6581 37.0498 37.08 36.627 37.4833 36.1868L22 22L36.2187 37.4541Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2187 37.4541C36.6581 37.0498 37.08 36.627 37.4833 36.1868L22 22L36.2187 37.4541Z",
    fill: "#F32A00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2187 37.4541C36.6581 37.0498 37.08 36.627 37.4833 36.1868L22 22L36.2187 37.4541Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-6-outside-6_4307_3126)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-7_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 23,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 21,
    y: 21,
    width: 23,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4182 26.9087C42.7025 25.7265 42.8835 24.5218 42.9592 23.3083L22 22L42.4182 26.9087Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4182 26.9087C42.7025 25.7265 42.8835 24.5218 42.9592 23.3083L22 22L42.4182 26.9087Z",
    fill: "#F5CC3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4182 26.9087C42.7025 25.7265 42.8835 24.5218 42.9592 23.3083L22 22L42.4182 26.9087Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-7-outside-7_4307_3126)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-8_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 0.999999,
    y: 5,
    width: 22,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.999999,
    y: 5,
    width: 22,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97496 5.52735C5.28873 8.44208 2.68667 12.509 1.5851 17.0774L22 22L8.97496 5.52735Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97496 5.52735C5.28873 8.44208 2.68667 12.509 1.5851 17.0774L22 22L8.97496 5.52735Z",
    fill: "#99439D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97496 5.52735C5.28873 8.44208 2.68667 12.509 1.5851 17.0774L22 22L8.97496 5.52735Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-8-outside-8_4307_3126)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-9_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: -9.60817e-7,
    y: 16,
    width: 23,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -9.60817e-7,
    y: 16,
    width: 23,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69872 16.628C1.22693 18.411 0.992068 20.2483 1.00021 22.0926L22 22L1.69872 16.628Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69872 16.628C1.22693 18.411 0.992068 20.2483 1.00021 22.0926L22 22L1.69872 16.628Z",
    fill: "#86BB00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69872 16.628C1.22693 18.411 0.992068 20.2483 1.00021 22.0926L22 22L1.69872 16.628Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-9-outside-9_4307_3126)"
  })), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-10_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 0.999998,
    y: 21,
    width: 24,
    height: 23,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.999998,
    y: 21,
    width: 24,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85799 27.9413C3.24315 32.6372 6.22555 36.7016 10.2896 39.4318C14.3536 42.1619 19.2439 43.3863 24.115 42.8932L22 22L1.85799 27.9413Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85799 27.9413C3.24315 32.6372 6.22555 36.7016 10.2896 39.4318C14.3536 42.1619 19.2439 43.3863 24.115 42.8932L22 22L1.85799 27.9413Z",
    fill: "#123051"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85799 27.9413C3.24315 32.6372 6.22555 36.7016 10.2896 39.4318C14.3536 42.1619 19.2439 43.3863 24.115 42.8932L22 22L1.85799 27.9413Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-10-outside-10_4307_3126)"
  })), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-11_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 21,
    width: 10,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 13,
    y: 21,
    width: 10,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4711 41.19C14.973 41.8576 16.5481 42.3465 18.164 42.6467L22 22L13.4711 41.19Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4711 41.19C14.973 41.8576 16.5481 42.3465 18.164 42.6467L22 22L13.4711 41.19Z",
    fill: "#86BB00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4711 41.19C14.973 41.8576 16.5481 42.3465 18.164 42.6467L22 22L13.4711 41.19Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-11-outside-11_4307_3126)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-outside-12_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: -0.00000122286,
    y: 21,
    width: 23,
    height: 8,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.00000122286,
    y: 21,
    width: 23,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 22C0.999999 24.047 1.29928 26.083 1.88837 28.0434L22 22L0.999999 22Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 22C0.999999 24.047 1.29928 26.083 1.88837 28.0434L22 22L0.999999 22Z",
    fill: "#F5CC3B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 22C0.999999 24.047 1.29928 26.083 1.88837 28.0434L22 22L0.999999 22Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-12-outside-12_4307_3126)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-13_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: -0.00000148748,
    width: 35,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: -0.00000148748,
    width: 35,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.197 19.3109 42.3184 15.3887 40.4275 11.9289C38.5367 8.46914 35.71 5.61156 32.271 3.68317C28.832 1.75478 24.9196 0.833487 20.9815 1.02471C17.0434 1.21594 13.2386 2.51196 10.0026 4.76447L22 22L42.963 23.2467Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.197 19.3109 42.3184 15.3887 40.4275 11.9289C38.5367 8.46914 35.71 5.61156 32.271 3.68317C28.832 1.75478 24.9196 0.833487 20.9815 1.02471C17.0434 1.21594 13.2386 2.51196 10.0026 4.76447L22 22L42.963 23.2467Z",
    fill: "#9AD4D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.197 19.3109 42.3184 15.3887 40.4275 11.9289C38.5367 8.46914 35.71 5.61156 32.271 3.68317C28.832 1.75478 24.9196 0.833487 20.9815 1.02471C17.0434 1.21594 13.2386 2.51196 10.0026 4.76447L22 22L42.963 23.2467Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-13-outside-13_4307_3126)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-14_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: -0.00000113748,
    width: 27,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 17,
    y: -0.00000113748,
    width: 27,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.1543 20.0296 42.6026 16.8117 41.3507 13.8421C40.0987 10.8724 38.1801 8.23078 35.7433 6.12167C33.3066 4.01256 30.4171 2.49259 27.2986 1.67944C24.1801 0.8663 20.9163 0.781805 17.7599 1.4325L22 22L42.963 23.2467Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.1543 20.0296 42.6026 16.8117 41.3507 13.8421C40.0987 10.8724 38.1801 8.23078 35.7433 6.12167C33.3066 4.01256 30.4171 2.49259 27.2986 1.67944C24.1801 0.8663 20.9163 0.781805 17.7599 1.4325L22 22L42.963 23.2467Z",
    fill: "#AAABAD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.963 23.2467C43.1543 20.0296 42.6026 16.8117 41.3507 13.8421C40.0987 10.8724 38.1801 8.23078 35.7433 6.12167C33.3066 4.01256 30.4171 2.49259 27.2986 1.67944C24.1801 0.8663 20.9163 0.781805 17.7599 1.4325L22 22L42.963 23.2467Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-14-outside-14_4307_3126)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-15_4307_3126",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 15,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8,
    y: 4,
    width: 15,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8716 4.19108C10.1534 4.63986 9.46297 5.13169 8.80416 5.66385L22 22L10.8716 4.19108Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8716 4.19108C10.1534 4.63986 9.46297 5.13169 8.80416 5.66385L22 22L10.8716 4.19108Z",
    fill: "#F5CC3B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8716 4.19108C10.1534 4.63986 9.46297 5.13169 8.80416 5.66385L22 22L10.8716 4.19108Z",
    stroke: "white",
    strokeWidth: 0.127002,
    mask: "url(#path-15-outside-15_4307_3126)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackroundWheel);
export default __webpack_public_path__ + "static/media/backroundWheel.c170dec1e2c3a437f8bafe0a07858029.svg";
export { ForwardRef as ReactComponent };